module.exports = __webpack_public_path__ + "img/cloud-sky-stock-photography-blue-sunlight-sky.38c051fc.jpg";